import React from 'react'
import { FooterProps } from './types'
import QuestLabs from "../../../../components/QuestLabs";
import { useOnboarding } from './OnboardingContext';

const Footer: React.FC<FooterProps> = ({
    formdata,
    showFooter,
    showPoweredBy = true, ...props }) => {

    const { themeManager, showFooter: contextShowFooter, formdata: contextFormdata } = useOnboarding();
    return (
        <>

            {(formdata || contextFormdata).length > 0 && (showFooter || contextShowFooter) && (
                <QuestLabs
                    style={themeManager?.getOnboardingFooterStyles()?.FooterStyle}
                    textStyle={themeManager?.getOnboardingFooterStyles()?.FooterTextStyle}
                    iconStyle={themeManager?.getOnboardingFooterStyles()?.FooterIcon}
                    text={themeManager?.getOnboardingFooterStyles()?.FooterText}
                    link={themeManager?.getOnboardingFooterStyles()?.FooterLink}
                />
            )}
        </>
    )
}

export default Footer